<template>
  <div class="popup popup-priceTips" :class="{ 'modal-in': isShow, 'modal-out': !isShow}" id="tagDetailPopup">
    <div class="shorexDetail-title js-returnDetailBtn">
      <p>礼遇详情</p>
      <a class="shorexDetail-returnButton close-popup" @click="goBack()">
        <img :src="`${imgUrl}/mobileSearchPackage/arrowRightBlack.png`">
      </a>
    </div>
    <div class="tag-detail">
      <div class="tag-detail-container">
        <img class="tag-detail-banner" :src="suiteImage"/>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "SuiteIntroducePopup",
  props: {
    onGoBack: {
      type: Function
    },
    isShow: {
      type: Boolean,
      default () {
        return false
      }
    },
    tags: {
      type: Array,
      default () {
        return []
      }
    },
    suiteImage: {
      type: String,
      default () {
        // return `${this.imgUrl}/mobile/details/suite/suite_introduce.png`,
        return ""
      }
    }
  },
  data() {
    return {
      imgUrl: process.env.VUE_APP_IMG_URL,
      projects: []
    }
  },
  created() {
    this.projects = [{
      title: "豪华住宿",
      src: `${this.imgUrl}/cruiseSearch/icons/icon-accommodation-blue.png`
    },{
      title: "寰宇美食",
      src: `${this.imgUrl}/cruiseSearch/icons/icon-fine-food-blue.png`
    },{
      title: "招牌演出",
      src: `${this.imgUrl}/cruiseSearch/icons/icon-signboard-show-blue.png`
    },{
      title: "水上乐园",
      src: `${this.imgUrl}/cruiseSearch/icons/icon-water-park-blue.png`
    },{
      title: "运动健身",
      src: `${this.imgUrl}/cruiseSearch/icons/icon-sports-blue.png`
    },{
      title: "室内外泳池",
      src: `${this.imgUrl}/cruiseSearch/icons/icon-swimming-pool-blue.png`
    },{
      title: "科技游乐",
      src: `${this.imgUrl}/cruiseSearch/icons/icon-science-amusement-blue.png`
    },{
      title: "派对游戏",
      src: `${this.imgUrl}/cruiseSearch/icons/icon-party-blue.png`
    },{
      title: "儿童青少年活动中心",
      src: `${this.imgUrl}/cruiseSearch/icons/icon-children-blue.png`
    }]
  },
  methods:{
    goBack() {
      this.onGoBack()
    }
  }
}
</script>

<style lang="less" scoped>
#tagDetailPopup.popup {
  position: fixed;
  background-color: #F6F7F8;
  transform: translate3d(100%, 0, 0);
  display: block;
}
#tagDetailPopup.modal-in {
  position: fixed;
  background-color: #F6F7F8;
  transform: translate3d(0, 0, 0);
}
#tagDetailPopup.modal-out {
  transform: translate3d(100%, 0, 0);
}

#tagDetailPopup {
  .shorexDetail-title {
    padding: 15px 20px;
    background-color: #fff;
    overflow: hidden;
    text-align: center;
    margin-bottom: 10px;
    position: fixed;
    width: 100%;
    z-index: 10;
    > p {
      
      font-size: 14px;
      color: #333333;
      letter-spacing: 1px;
      text-align: center;
      margin: 0;
    }
    .shorexDetail-returnButton {
      width: 30px;
      position: absolute;
      top: 15px;
      left: 20px;
      text-align: left;
      > img {
        width: 33%;
      }
    }
  }
  .tagDetail {
    height: calc(100% - 50px);
    padding-bottom: 50px;
    margin-top: 50px;
    overflow-x: hidden;
    overflow-y: auto;
    .tagDetail-container {
      padding: 15px 20px;
      background-color: #fff;
      border-top: 10px solid #F6F7F8;
    }
  }
}

.tag-detail {
  height: calc(100% - 50px);
  padding-bottom: 50px;
  margin-top: 50px;
  overflow-x: hidden;
  overflow-y: auto;
  & .tag-detail-container {
    margin-top: 10px;
    padding: 15px 0;
    background-color: #FFFFFF;
    & .tag-detail-banner {
      display: block;
      width: 90%;
      margin: 0 auto;
    }
    & .tag-padding {
      padding: 15px 20px;
    }
  }
}
.project-list {
  width: 85%;
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
  & li {
    width: 47%;
    margin: 0 1.5%;
    overflow: hidden;
    padding: 0.25rem 0;
    &.is-full {
      width: 100%;
    }
    & > img {
      float: left;
      height: 1.2rem;
    }
    & > div {
      float: left;
      line-height: 1.2rem;
      font-size: 14px;
      text-align: center;
      margin-left: 0.25rem;
    }
  }
}
</style>

